import {initNavigation} from './navigation.js';
import {initFilter} from './filter.js';
import {initGallery} from './gallery.js';
import {initSearch} from './search.js';

document.addEventListener('DOMContentLoaded', () => {
    initNavigation();
    initFilter();
    initGallery();
    initSearch();
});
